import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import Header from "components/Header";
import { toast } from "react-toastify";
import { Box, Dialog, DialogTitle, DialogActions } from "@mui/material";
import { GiWallet } from "react-icons/gi";
import moment from "moment";
import Tooltip from "@mui/material/Tooltip";
import {
    getAllProperties,
    getAllContract,
    deleteContract,
    getAllTenants,
    getAllBanks,
} from "state/apis";
import Add from "./Add.jsx";
import { InputBase } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import Document from "./Document.js";
import PDC from "./PDC.jsx";
import { IoReceiptSharp } from "react-icons/io5";
import Receipt from "./Receipt.jsx";
import DefaultProperty from "components/DefaultProperty.jsx";
import RenewPopup from "components/Renew.jsx";
import { useDispatch, useSelector } from "react-redux";
import { MdAutorenew } from "react-icons/md";
import { IoMdCloseCircleOutline } from "react-icons/io";
import Termination from "components/Termination.jsx";
import { getDefaultProperty } from "state/index.js";
import Voucher from "./Voucher.jsx";
import DescriptionIcon from "@mui/icons-material/Description";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import PaidIcon from "@mui/icons-material/Paid";
import { Typography } from "@mui/material";

const Contract = () => {
    const [isLoading, setIsLoading] = React.useState(true);
    const [data, setData] = React.useState([]);
    const [totalData, setTotalData] = React.useState([]);
    const [openAddForm, setOpenAddForm] = React.useState(false);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const [balance, setBalance] = React.useState(0);
    const [renewMode, setRenewName] = React.useState(false);
    const [deleteConfirmationOpen, setDeleteConfirmationOpen] = React.useState(false);
    const [renewOpen, setRenewOpen] = React.useState(false);
    const [terminationOpen, setTerminationOpen] = React.useState(false);
    const [voucherOpen, setVoucherOpen] = React.useState(false);
    const [deleteItem, setDeleteItem] = React.useState(null);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(50);
    const [property, setProperty] = React.useState([]);
    const [tenants, setTenants] = React.useState([]);
    const [banks, setBanks] = React.useState([]);
    const [searchQuery, setSearchQuery] = React.useState("");
    const inputRef = React.useRef(null);
    const [openDocList, setOpenDocList] = React.useState(false);
    const [openPdcList, setOpenPdcList] = React.useState(false);
    const [openReceipt, setOpenReceipt] = React.useState(false);
    const [openDefaultProperty, setOpenDefaultProperty] = React.useState(false);
    const defaultProperty = useSelector((state) => state.global.defaultProperty);
    const dispatch = useDispatch();
    const [role, setRole] = React.useState({});
    const [isSoldProperty, setIsSoldProperty] = React.useState(false);

    React.useEffect(() => {
        fetchData();
        fetchProperty();
        fetchTenants();
        fetchBanks();
        fetchRole();
        if (!defaultProperty) {
            setOpenDefaultProperty(true);
        }
    }, [page, rowsPerPage, searchQuery]);

    const fetchRole = async () => {
        const res = await getDefaultProperty(dispatch);
        setIsSoldProperty(res?.data?.property?.isSold);
        if (res?.data?.role && res?.data?.role?.permission) {
            setRole(JSON.parse(res?.data?.role?.permission));
        }
    };

    const fetchData = async () => {
        try {
            // setIsLoading(true);
            const res = await getAllContract(
                rowsPerPage,
                page * rowsPerPage,
                searchQuery,
                defaultProperty
            );
            setData(res?.contract);
            setTotalData(res?.totalCount);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error);
            toast.error("Failed to fetch data. Please try again.");
        }
    };

    const fetchProperty = async () => {
        try {
            const res = await getAllProperties(100000, 0);
            setProperty(res?.property);
        } catch (error) {
            console.error("Error fetching property:", error);
            toast.error("Failed to fetch property. Please try again.");
        }
    };

    const fetchTenants = async () => {
        try {
            const res = await getAllTenants(100000, 0);
            setTenants(res?.data);
        } catch (error) {
            console.error("Error fetching property:", error);
            toast.error("Failed to fetch property. Please try again.");
        }
    };

    const fetchBanks = async () => {
        try {
            const res = await getAllBanks(100000, 0);
            setBanks(res?.data);
        } catch (error) {
            console.error("Error fetching banks:", error);
            toast.error("Failed to fetch banks. Please try again.");
        }
    };

    const handleCloseDefaultProperty = () => {
        setOpenDefaultProperty(false);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleAddContract = () => {
        setSelectedRow(null);
        setOpenAddForm(true);
    };

    const handleCloseAddForm = () => {
        setOpenAddForm(false);
        setRenewName(false);
    };

    const handleSubmitAddContract = async () => {
        setOpenAddForm(false);
        setIsLoading(true);
        fetchData();
    };
    const handleSubmitRenewContract = async () => {
        setOpenAddForm(true);
        setRenewName(true);
        fetchData();
    };

    const handleEditClick = (row) => {
        setSelectedRow(row);
        setOpenAddForm(true);
    };

    const handleDeleteClick = (row) => {
        setDeleteItem(row?.id);
        setDeleteConfirmationOpen(true);
    };

    const handleDeleteConfirmation = async () => {
        try {
            await deleteContract(deleteItem);
            toast.success("Contract registration deleted successfully.");
            fetchData();
            setDeleteConfirmationOpen(false);
        } catch (error) {
            console.error("Error deleting contract registration:", error);
            toast.error("Failed to delete contract registration. Please try again.");
        }
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleSearch = () => {
        fetchData();
    };

    const handleDocClick = (row) => {
        setSelectedRow(row);
        setOpenDocList(true);
    };
    const handleCloseDocList = () => {
        setOpenDocList(false);
    };

    const handlePdcClick = (row) => {
        setSelectedRow(row);
        setOpenPdcList(true);
    };
    const handleRenewClick = (row, balance) => {
        setRenewOpen(true);
        setSelectedRow(row);
        setBalance(balance);
    };

    const handleTerminationClick = (row, balance) => {
        setTerminationOpen(true);
        setSelectedRow(row);
    };
    const handleVoucherClick = (row) => {
        setVoucherOpen(true);
        setSelectedRow(row);
    };

    const handleClosePdcList = () => {
        setOpenPdcList(false);
    };

    const focusInput = () => {
        inputRef.current.focus();
    };

    const handleCloseReceipt = () => {
        setOpenReceipt(false);
        fetchData();
    };

    const handleCloseVoucher = () => {
        setVoucherOpen(false);
        fetchData();
    };

    if (isLoading) {
        return (
            <Box sx={{ p: "24px 28px" }}>
                <Header title="Contracts" />
                <Box sx={{ mt: 4, textAlign: "center", color: "#5a6a85" }}>Loading...</Box>
            </Box>
        );
    }

    const totalContracts = data?.length || 0;
    const overdueContracts = data?.filter((r) => Number(r?.dayDiff) < 0).length || 0;
    const totalYearlyRent = data?.reduce((sum, r) => sum + (Number(r?.yearRent) || 0), 0) || 0;
    const totalReceived = data?.reduce((sum, r) => sum + (Number(r?.totalReceivedRent) || 0), 0) || 0;
    const totalBalance = totalYearlyRent - totalReceived;

    const metricCards = [
        { label: "Total Contracts", value: totalContracts, icon: <DescriptionIcon />, color: "#1976d2" },
        { label: "Overdue", value: overdueContracts, icon: <WarningAmberIcon />, color: "#d32f2f" },
        { label: "Total Yearly Rent", value: totalYearlyRent.toLocaleString(), icon: <AccountBalanceWalletIcon />, color: "#2e7d32" },
        { label: "Total Received", value: totalReceived.toLocaleString(), icon: <PaidIcon />, color: "#1976d2" },
        { label: "Total Balance", value: totalBalance.toLocaleString(), icon: <GiWallet size={24} />, color: totalBalance > 0 ? "#ed6c02" : "#2e7d32" },
    ];

    return (
        <Box sx={{ p: "24px 28px" }}>
            <Header title="Contracts" subtitle="List of Contract Registration" />
            <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap" }}>
                {metricCards.map((card, i) => (
                    <Paper
                        key={i}
                        sx={{
                            flex: "1 1 160px",
                            p: 2,
                            borderRadius: "12px",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                            display: "flex",
                            alignItems: "center",
                            gap: 1.5,
                        }}
                    >
                        <Box sx={{ color: card.color, display: "flex", alignItems: "center" }}>
                            {card.icon}
                        </Box>
                        <Box>
                            <Typography sx={{ fontSize: "0.7rem", color: "#5a6a85", fontWeight: 500 }}>
                                {card.label}
                            </Typography>
                            <Typography sx={{ fontSize: "1.1rem", fontWeight: 700, color: card.color }}>
                                {card.value}
                            </Typography>
                        </Box>
                    </Paper>
                ))}
            </Box>
            <Paper
                sx={{
                    width: "100%",
                    overflow: "hidden",
                    mt: 2.5,
                    borderRadius: "12px",
                    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
                }}
            >
                <Box display="flex" justifyContent="space-between" alignItems="center" p={2}>
                    <Box display="flex" alignItems="center" sx={{ flex: 1 }}>
                        <InputBase
                            placeholder="Search by name, unit, nationality, emirates ID..."
                            sx={{
                                backgroundColor: "#eef1f6",
                                borderRadius: "8px",
                                px: 1.5,
                                py: 0.5,
                                fontSize: "0.8125rem",
                                width: "100%",
                                maxWidth: 450,
                            }}
                            inputRef={inputRef}
                            value={searchQuery}
                            onChange={handleSearchChange}
                            onFocus={focusInput}
                        />
                        <IconButton onClick={handleSearch}>
                            <SearchIcon />
                        </IconButton>
                    </Box>
                    {role?.contract?.add && !isSoldProperty && (
                        <Button variant="contained" color="primary" size="small" onClick={handleAddContract}>
                            Add Contract Registration
                        </Button>
                    )}
                </Box>
                <TableContainer sx={{ overflowX: "auto", maxHeight: 900 }}>
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Property Name</TableCell>
                                <TableCell>Unit</TableCell>
                                <TableCell>Yearly Rent</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Deposit</TableCell>
                                <TableCell>Contract From</TableCell>
                                <TableCell>Contract To</TableCell>
                                <TableCell>Rent Paid Upto</TableCell>
                                <TableCell>Rent Paid Days</TableCell>
                                <TableCell>Total Receipt</TableCell>
                                <TableCell>Balance</TableCell>
                                <TableCell>Documents</TableCell>
                                <TableCell>PDC</TableCell>
                                {!isSoldProperty && (
                                    <>
                                        <TableCell>Contract Actions</TableCell>
                                        {(role?.contract?.delete || role?.contract?.update) && (
                                            <TableCell>Actions</TableCell>
                                        )}
                                    </>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row) => (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.id}
                                    sx={Number(row?.dayDiff) < 0 ? { '& td, & th': { backgroundColor: "#ffebee !important" } } : {}}
                                >
                                    <TableCell>{row.property.propertyName}</TableCell>
                                    <TableCell>{row.unit.unitNumber}</TableCell>
                                    <TableCell>{row.yearRent}</TableCell>
                                    <TableCell>{row.tenant.name}</TableCell>
                                    <TableCell>{row.deposit ? row.deposit : "-"}</TableCell>
                                    <TableCell>
                                        {row.contractFrom
                                            ? moment(row.contractFrom).format("DD/MM/YYYY")
                                            : "-"}
                                    </TableCell>
                                    <TableCell>
                                        {row.contractTo
                                            ? moment(row.contractTo).format("DD/MM/YYYY")
                                            : "-"}
                                    </TableCell>
                                    <TableCell>{row?.paidUntilDate}</TableCell>
                                    <TableCell>
                                        <span style={{
                                            color: Number(row?.dayDiff) < 0 ? "#d32f2f" : "inherit",
                                            fontWeight: Number(row?.dayDiff) < 0 ? 700 : "normal",
                                        }}>
                                            {row?.dayDiff}
                                        </span>
                                    </TableCell>
                                    <TableCell>
                                        {row.totalReceivedRent ? row.totalReceivedRent : "-"}
                                    </TableCell>
                                    <TableCell>{row.yearRent - row.totalReceivedRent}</TableCell>
                                    <TableCell>
                                        {row?.contractDocument?.length > 0 && (
                                            <IconButton onClick={() => handleDocClick(row)}>
                                                <VisibilityIcon />
                                            </IconButton>
                                        )}
                                    </TableCell>
                                    <TableCell>
                                        {row?.pdcs?.length > 0 && (
                                            <IconButton onClick={() => handlePdcClick(row)}>
                                                <RequestQuoteIcon />
                                            </IconButton>
                                        )}
                                    </TableCell>
                                    {!isSoldProperty && (
                                        <>
                                            <TableCell sx={{ whiteSpace: "nowrap" }}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    size="small"
                                                    sx={{ fontSize: "0.7rem", py: 0.3, px: 1, mr: 0.5, minWidth: "auto" }}
                                                    onClick={() =>
                                                        handleRenewClick(
                                                            row,
                                                            row?.yearRent - row?.totalReceivedRent
                                                        )
                                                    }
                                                >
                                                    Renew
                                                </Button>
                                                {row?.paidUntilDate !== "-" && (
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        size="small"
                                                        sx={{ fontSize: "0.7rem", py: 0.3, px: 1, minWidth: "auto" }}
                                                        onClick={() => handleTerminationClick(row)}
                                                    >
                                                        Terminate
                                                    </Button>
                                                )}
                                            </TableCell>
                                            {(role?.contract?.delete || role?.contract?.update) && (
                                                <TableCell sx={{ whiteSpace: "nowrap" }}>
                                                    <Button
                                                        variant="contained"
                                                        color="primary"
                                                        size="small"
                                                        sx={{ fontSize: "0.7rem", py: 0.3, px: 1, mr: 0.5, minWidth: "auto" }}
                                                        onClick={() => handleVoucherClick(row)}
                                                    >
                                                        Receipt Voucher
                                                    </Button>
                                                    {role?.contract?.update && (
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleEditClick(row)}
                                                        >
                                                            <EditIcon fontSize="small" />
                                                        </IconButton>
                                                    )}
                                                    {role?.contract?.delete && (
                                                        <IconButton
                                                            size="small"
                                                            color="error"
                                                            onClick={() => handleDeleteClick(row)}
                                                        >
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    )}
                                                </TableCell>
                                            )}
                                        </>
                                    )}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={totalData}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                <Add
                    open={openAddForm}
                    onClose={handleCloseAddForm}
                    onSubmit={handleSubmitAddContract}
                    editData={selectedRow}
                    editMode={!!selectedRow}
                    renewMode={renewMode}
                    property={property}
                    tenants={tenants}
                    banks={banks}
                    isSold={isSoldProperty}
                />
                {openDocList && (
                    <Document
                        open={openDocList}
                        onClose={handleCloseDocList}
                        editData={selectedRow}
                        editMode={!!selectedRow}
                        isSold={isSoldProperty}
                    />
                )}

                {openPdcList && (
                    <PDC
                        open={openPdcList}
                        onClose={handleClosePdcList}
                        editData={selectedRow}
                        editMode={!!selectedRow}
                        isSold={isSoldProperty}
                    />
                )}

                {openReceipt && (
                    <Receipt
                        open={openReceipt}
                        onClose={handleCloseReceipt}
                        receiptData={selectedRow}
                        receiptOpenMode={!!selectedRow}
                    />
                )}

                {voucherOpen && (
                    <Voucher
                        open={voucherOpen}
                        onClose={handleCloseVoucher}
                        editData={selectedRow}
                        editMode={!!selectedRow}
                        banks={banks}
                        onSubmit={() => {
                            setVoucherOpen(false);
                            setIsLoading(true);
                            fetchData();
                        }}
                    />
                )}

                {!defaultProperty && (
                    <DefaultProperty
                        open={openDefaultProperty}
                        onClose={() => handleCloseDefaultProperty}
                    />
                )}
                {renewOpen && (
                    <RenewPopup
                        open={renewOpen}
                        editData={selectedRow}
                        onClose={() => setRenewOpen(false)}
                        onSubmit={handleSubmitRenewContract}
                        balance={balance}
                    />
                )}
                {terminationOpen && (
                    <Termination
                        open={terminationOpen}
                        editData={selectedRow}
                        onClose={() => setTerminationOpen(false)}
                        onSubmit={() => fetchData()}
                    />
                )}
                <Dialog
                    open={deleteConfirmationOpen}
                    onClose={() => setDeleteConfirmationOpen(false)}
                >
                    <DialogTitle fontWeight={"bold"}>Are you sure you want to delete?</DialogTitle>
                    <DialogActions>
                        <Button
                            onClick={() => setDeleteConfirmationOpen(false)}
                            sx={{ color: "#5a6a85" }}
                        >
                            Cancel
                        </Button>
                        <Button onClick={handleDeleteConfirmation} color="error" autoFocus>
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
            </Paper>
        </Box>
    );
};

export default Contract;
